import { DDE_ENDPOINTS } from '@/service/constants/ddeEndpoints'
import { ddeApi } from '@/service/ddeApi'
import { fetchData } from '@/service/request'
import type { DistributionListRecipient } from '@/types/dde/distributionList'

import { createBaseTableStore } from '../table'
import type { FetchApiArgs, FetchApiResponse } from '../table/table.types'

export type DistributionRecipientWithOperatorName = Omit<
  DistributionListRecipient,
  'operatorId'
> & {
  operatorName?: string
  operatorId?: number
}

const fetchDistributionRecipientsApiCallback = async (
  args: FetchApiArgs<unknown, string, string>
): Promise<FetchApiResponse<DistributionRecipientWithOperatorName>> => {
  const { signal } = args

  const [recipients, { data: operators }] = await Promise.all([
    fetchData<DistributionListRecipient[]>({
      endpointData: DDE_ENDPOINTS.Timeline.Emails.get,
      options: { signal }
    }),
    ddeApi.endpoints.operators.getAll(signal)
  ])

  const operatorIdNameMap = Object.fromEntries(
    operators.map((operator) => [operator.id, operator.name])
  )

  const usersMappedWithOperatorName: DistributionRecipientWithOperatorName[] = recipients.map(
    (recipient) => ({
      ...recipient,
      operatorName:
        'operatorId' in recipient && recipient.operatorId
          ? operatorIdNameMap[recipient.operatorId]
          : undefined,
      operatorId: 'operatorId' in recipient ? recipient.operatorId : undefined
    })
  )

  return {
    content: usersMappedWithOperatorName,
    totalElements: usersMappedWithOperatorName.length
  }
}

export const useDistributionRecipients = createBaseTableStore({
  storeName: 'Distribution Recipients',
  fetchApi: fetchDistributionRecipientsApiCallback
})
